module.exports = require('./src/vue-timepicker.vue')



//////////////////
// WEBPACK FOOTER
// ./~/vue2-timepicker/index.js
// module id = 44
// module chunks = 0